import {
  FETCH_PATIENT_REQUEST,
  FETCH_PATIENT_SUCCESS,
  FETCH_PATIENT_FAILURE,
} from "./patientTypes";

const initialState = {
  loading: false,
  patient: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PATIENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PATIENT_SUCCESS:
      return {
        loading: false,
        patient: action.payload,
        error: "",
      };
    case FETCH_PATIENT_FAILURE:
      return {
        loading: false,
        patient: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
